import React from 'react'

import { TagManagerConsumer } from 'context/TagManagerContext'

export default WrappedComponent => props => (
  <TagManagerConsumer>
    {tagManager => <WrappedComponent {...props} {...tagManager} />}
  </TagManagerConsumer>
)
